import type { getSecureNotesApi } from '@frontend/api-client';
import type { LocalFile, ReplaceSecureNoteInput, TypedFormData } from '@frontend/api-types';
import type { Logger, SnakeCasedProperties } from '@frontend/duck-tape';
import type { SecureNoteFormSchema } from '@frontend/forms';
import type { APIMutation, GetMutationUtilArgs } from '@frontend/react-domain/utils/mutations';

export type UpdateSecureNoteArgs = GetMutationUtilArgs<{ secureNoteId: string }> & {
  data: SecureNoteFormSchema;
  formDataClass: typeof TypedFormData;
  logger?: Logger;
  secureNoteId: string;
  updateSecureNoteMutation: APIMutation<typeof getSecureNotesApi, 'useReplaceSecureNoteContentMutation'>;
};

export const updateSecureNote = async ({
  data,
  formDataClass,
  handleMutation,
  handleMutationOptions,
  secureNoteId,
  updateSecureNoteMutation,
}: UpdateSecureNoteArgs) => {
  const { attachments, notes, password, username, website } = data;

  return handleMutation({
    mutation: async () => {
      const formData = new formDataClass<SnakeCasedProperties<ReplaceSecureNoteInput>>();

      if (attachments.length) formData.appendLocalFiles('attachments', attachments as LocalFile[]);
      if (notes) formData.append('notes', notes);
      if (password) formData.append('password', password);
      if (username) formData.append('username', username);
      if (website) formData.append('website', website);

      await updateSecureNoteMutation({ formData, secureNoteId }).unwrap();
      return { secureNoteId };
    },
    successMessage: 'Successfully updated.',
    ...handleMutationOptions,
  });
};
